import { render, staticRenderFns } from "./LinkDetail.vue?vue&type=template&id=f4b939fe&"
import script from "./LinkDetail.vue?vue&type=script&lang=js&"
export * from "./LinkDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports